import React from 'react'

const ControllNsProovedorContainer = () => (
  <>
    <iframe
      title="Fill Rate"
      width="100%"
      height="90%"
      src="https://app.powerbi.com/reportEmbed?reportId=183c99fb-b462-4b53-8756-45f778b8f24b&autoAuth=true&ctid=1a8e863a-6a66-4905-990b-f7062b267787"
      frameBorder="0"
      allowFullScreen="true"
      />
  </> 
)

export default ControllNsProovedorContainer
